/* =========================================================
   Kipor Vermietung — Mietrechner
   ---------------------------------------------------------
   Vierstufiger Funnel, der aus "ich weiss nicht, wie viel kVA
   ich brauche" eine qualifizierte Anfrage macht.

   Auslegung (Schritt 2):
     Dauerlast  = Summe der Nennleistungen aller gewaehlten Verbraucher
     Anlaufspitze = Dauerlast + groesster einzelner Anlaufzuschlag
                    (kW * (Anlauffaktor - 1)). Es laeuft nicht alles
                    gleichzeitig an, deshalb nur der groesste Zuschlag.
     Scheinleistung = Anlaufspitze / cos phi (0,8) * 1,15 Reserve

   Der Versand laeuft ueber das native Shopify-Kontaktformular
   (POST + Reload). Schritt 5 wird nach erfolgreichem Versand
   serverseitig via data-posted aktiviert; die Zusammenfassung
   kommt aus sessionStorage, weil der State den Reload nicht
   ueberlebt.
   ========================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-kpr-calc]');
  if (!root) return;

  var SS_KEY = 'kpr-summary';

  // Anzeigetexte aus den Locale-Dateien (kipor.rent.js.*), deutscher
  // Originaltext als Fallback. Texte, die nur in der Anfrage-Mail an den
  // Shop landen (versteckte Felder, contact[body]), bleiben bewusst deutsch.
  var T = (window.KiporStrings && window.KiporStrings.rent) || {};

  /* ─────────────────────────────
     Datenbasis
     ───────────────────────────── */

  // Leistungsklassen. kw = Wirkleistung bei cos phi 0,8.
  var FLEET = [
    { kva: 30,   kw: 24,   use: 'Baustrom, kleine Werkstatt, Marktstände' },
    { kva: 60,   kw: 48,   use: 'Kleinbaustelle, Straßenfest, Notbetrieb Büro' },
    { kva: 125,  kw: 100,  use: 'Baustelle mit Kran, mittlere Veranstaltung' },
    { kva: 200,  kw: 160,  use: 'Hochbau, Bühnentechnik, Kühlhaus' },
    { kva: 320,  kw: 256,  use: 'Netzersatz Gewerbebetrieb, Festival' },
    { kva: 350,  kw: 280,  use: 'Produktion, Trafowechsel' },
    { kva: 500,  kw: 400,  use: 'Industrie, große Veranstaltung, Rechenzentrum' },
    { kva: 800,  kw: 640,  use: 'Netzersatz Werksteil, Anlagenerweiterung' },
    { kva: 1000, kw: 800,  use: 'Interimsversorgung Standort' },
    { kva: 1250, kw: 1000, use: 'Großprojekt, Umspannbetrieb' },
    { kva: 1500, kw: 1200, use: 'Kraftwerksersatz, Großindustrie' }
  ];

  // Die Verbraucher kommen aus dem HTML, nicht von hier: sie stehen
  // server-gerendert in der Section, damit Suchmaschinen sie sehen.
  // Dieses Skript liest nur die Kennwerte aus den data-Attributen.
  // f = Anlauffaktor (Verhaeltnis Anlaufstrom zu Nennstrom).
  var LOADS = [];

  // `phrase` steht als Einschub im Satz "Typische Verbraucher <phrase> sind
  // vorausgewählt" — ausgeschrieben, weil ein automatisch kleingeschriebener
  // Titel ("für baustelle") falsches Deutsch ergibt.
  //
  // i18n: `t` ist der DEUTSCHE Wert fuer Anfrage-Mail und Tracking,
  // `label`/`s`/`hint` sind die angezeigten (uebersetzten) Texte.
  // `hint` = ganzer Satz statt Einschub, damit jede Sprache ihre
  // eigene Wortstellung hat.
  var CHIP_HINT_TAIL = ' sind schon angekreuzt. Setzen Sie Haken dazu oder nehmen Sie welche weg – ' +
    'die Berechnung passt sich sofort an.';
  var USES = [
    { id: 'bau',   t: 'Baustelle',     label: T.use_bau_title || 'Baustelle',       s: T.use_bau_sub || 'Baustrom, Kran, Werkzeug',         hint: T.use_bau_hint || 'Typische Verbraucher für eine Baustelle' + CHIP_HINT_TAIL,              icon: 'construction' },
    { id: 'event', t: 'Veranstaltung', label: T.use_event_title || 'Veranstaltung', s: T.use_event_sub || 'Bühne, Catering, Licht',         hint: T.use_event_hint || 'Typische Verbraucher für eine Veranstaltung' + CHIP_HINT_TAIL,        icon: 'celebration' },
    { id: 'netz',  t: 'Netzersatz',    label: T.use_netz_title || 'Netzersatz',     s: T.use_netz_sub || 'Wartung, Umbau, Produktion',      hint: T.use_netz_hint || 'Typische Verbraucher für einen Netzersatz' + CHIP_HINT_TAIL,           icon: 'bolt' },
    { id: 'komm',  t: 'Kommune & BOS', label: T.use_komm_title || 'Kommune & BOS',  s: T.use_komm_sub || 'Vorsorge, Feuerwehr, Leitstelle', hint: T.use_komm_hint || 'Typische Verbraucher für Kommunen und Einsatzkräfte' + CHIP_HINT_TAIL, icon: 'local_fire_department' }
  ];

  var DURS = [
    { t: 'Bis 7 Tage',    label: T.dur_1_title || 'Bis 7 Tage',    s: T.dur_1_sub || 'Event, Wartungsfenster', icon: 'today' },
    { t: '1–4 Wochen',    label: T.dur_2_title || '1–4 Wochen',    s: T.dur_2_sub || 'Bauabschnitt, Umbau',    icon: 'date_range' },
    { t: '1–6 Monate',    label: T.dur_3_title || '1–6 Monate',    s: T.dur_3_sub || 'Projekt, Netzersatz',    icon: 'calendar_month' },
    { t: 'Über 6 Monate', label: T.dur_4_title || 'Über 6 Monate', s: T.dur_4_sub || 'Dauerbetrieb, Interim',  icon: 'event_repeat' }
  ];

  /* ─────────────────────────────
     State & Helfer
     ───────────────────────────── */
  var S = { use: null, useLabel: '', sel: [], load: 0, peak: 0, kva: 0, unit: null, dur: null, manual: false };

  var $ = function (sel) { return root.querySelector(sel); };
  // Anzeige im Format der Seitensprache; die Anfrage-Mail an den Shop bleibt deutsch (fmtDe).
  var PAGE_LANG = ((document.documentElement.getAttribute('lang') || 'de').slice(0, 2) || 'de').toLowerCase();
  var fmtDe = function (n) { return Number(n).toLocaleString('de-DE'); };
  // Einheiten nur für die Anzeige; Anfrage-Mail und Formularfelder bleiben lateinisch.
  var UNIT_KW = PAGE_LANG === 'uk' ? ' кВт' : ' kW';
  var UNIT_KVA = PAGE_LANG === 'uk' ? ' кВА' : ' kVA';
  var fmt = function (n) {
    if (PAGE_LANG === 'de') return fmtDe(n);
    try { return Number(n).toLocaleString(PAGE_LANG); } catch (e) { return fmtDe(n); }
  };

  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, kpr: data || {} });
  }

  /* ─────────────────────────────
     Schrittsteuerung
     ───────────────────────────── */
  var stepLabel = function (n) { return (T.step || 'Schritt [n] von 4').replace('[n]', n); };
  var STEPS = {
    s1:  { label: stepLabel(1), pct: 25 },
    s2:  { label: stepLabel(2), pct: 50 },
    s2b: { label: stepLabel(2), pct: 50 },
    s3:  { label: stepLabel(3), pct: 75 },
    s4:  { label: stepLabel(4), pct: 100 },
    s5:  { label: T.step_done || 'Fertig', pct: 100 }
  };

  var stepEls = {};
  Object.keys(STEPS).forEach(function (id) {
    stepEls[id] = root.querySelector('[data-step="' + id + '"]');
  });

  var barEl = $('[data-kpr-bar]');
  var countEl = $('[data-kpr-count]');
  var liveEl = $('[data-kpr-live]');

  // Wird weiter unten mit der echten Funktion belegt, sobald die
  // Sticky-Leiste verdrahtet ist. show() ruft sie auf, damit die Leiste
  // auch auf einen Schrittwechsel reagiert und nicht nur auf Scrollen.
  var syncSticky = function () {};

  function show(id, opts) {
    opts = opts || {};
    Object.keys(stepEls).forEach(function (key) {
      if (stepEls[key]) stepEls[key].classList.toggle('is-active', key === id);
    });
    if (countEl) countEl.textContent = STEPS[id].label;
    if (barEl) barEl.style.width = STEPS[id].pct + '%';
    if (liveEl) liveEl.textContent = (T.step_live || '[label] von 4').replace('[label]', STEPS[id].label);

    if (id === 's4') renderResult();

    if (opts.scroll !== false) {
      // Auf Mobil rutscht der Rechner sonst aus dem Bild, sobald ein
      // Schritt laenger wird als der vorherige.
      var top = root.getBoundingClientRect().top + window.pageYOffset - 84;
      if (window.innerWidth < 990 || opts.force) {
        window.scrollTo({ top: top, behavior: opts.instant ? 'auto' : 'smooth' });
      }
    }
    syncSticky();
    track('kpr_step', { step: id, kva: S.kva });
  }

  root.addEventListener('click', function (e) {
    var back = e.target.closest('[data-kpr-back]');
    if (back) {
      e.preventDefault();
      show(back.getAttribute('data-kpr-back'));
    }
  });

  /* ─────────────────────────────
     Schritt 1 — Einsatzzweck
     ───────────────────────────── */
  var tilesEl = $('[data-kpr-uses]');
  USES.forEach(function (u) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kpr-tile';
    b.innerHTML =
      '<span class="kpr-tile__icon"><span class="material-symbols-outlined" aria-hidden="true">' + u.icon + '</span></span>' +
      '<span class="kpr-tile__text"><b>' + u.label + '</b><small>' + u.s + '</small></span>';
    b.addEventListener('click', function () {
      S.use = u.id;
      S.useLabel = u.t;
      S.manual = false;
      buildChips(u.id);
      var sub = $('[data-kpr-chipsub]');
      if (sub) {
        sub.textContent = u.hint;
      }
      show('s2');
    });
    tilesEl.appendChild(b);
  });

  /* ─────────────────────────────
     Schritt 2 — Verbraucher
     ───────────────────────────── */
  var chipsEl = $('[data-kpr-chips]');
  var nextS3 = $('[data-kpr-next="s3"]');

  // Kennwerte aus dem gerenderten HTML einlesen und das Verhalten
  // ergaenzen. Die Schaltflaechen selbst existieren schon.
  [].slice.call(chipsEl.querySelectorAll('.kpr-chip')).forEach(function (el) {
    var l = {
      el: el,
      id: el.getAttribute('data-load'),
      n: el.getAttribute('data-name'),
      kw: parseFloat(el.getAttribute('data-kw')),
      f: parseFloat(el.getAttribute('data-f')),
      tags: (el.getAttribute('data-tags') || '').split(' ')
    };
    LOADS.push(l);
    el.addEventListener('click', function () {
      var pressed = el.getAttribute('aria-pressed') === 'true';
      el.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      if (pressed) {
        S.sel = S.sel.filter(function (x) { return x !== l.id; });
      } else {
        S.sel.push(l.id);
      }
      calc();
    });
  });

  // Es werden nur die Verbraucher gezeigt, die zum gewaehlten Einsatz
  // passen. Alle dreizehn auf einmal ergaben auf dem Handy eine Liste
  // ueber mehrere Bildschirme, an deren Ende erst das Ergebnis stand —
  // der Rest steckt hinter einer Schaltflaeche. Ausgeblendet wird per
  // Klasse, nicht durch Entfernen: der Text bleibt im Dokument.
  function buildChips(useId) {
    S.sel = [];
    var rel = LOADS.filter(function (l) { return l.tags.indexOf(useId) > -1; });
    var rest = LOADS.filter(function (l) { return l.tags.indexOf(useId) < 0; });
    var pre = rel.slice(0, 3).map(function (l) { return l.id; });

    LOADS.forEach(function (l) {
      var checked = pre.indexOf(l.id) > -1;
      l.el.classList.toggle('kpr-chip--extra', l.tags.indexOf(useId) < 0);
      l.el.setAttribute('aria-pressed', checked ? 'true' : 'false');
      if (checked) S.sel.push(l.id);
    });

    // Passende nach oben sortieren
    rel.concat(rest).forEach(function (l) { chipsEl.appendChild(l.el); });

    chipsEl.setAttribute('data-collapsed', 'true');
    if (moreBtn) {
      moreBtn.hidden = rest.length === 0;
      moreBtn.setAttribute('aria-expanded', 'false');
      moreBtn.querySelector('[data-kpr-more-label]').textContent =
        (T.more_count || 'Weitere [count] Verbraucher anzeigen').replace('[count]', rest.length);
    }
    calc();
  }

  var moreBtn = $('[data-kpr-more]');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var open = chipsEl.getAttribute('data-collapsed') !== 'true';
      chipsEl.setAttribute('data-collapsed', open ? 'true' : 'false');
      moreBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var hidden = chipsEl.querySelectorAll('.kpr-chip--extra').length;
      moreBtn.querySelector('[data-kpr-more-label]').textContent = open
        ? (T.more_count || 'Weitere [count] Verbraucher anzeigen').replace('[count]', hidden)
        : (T.more_hide || 'Weitere Verbraucher ausblenden');
    });
  }

  function calc() {
    var items = LOADS.filter(function (l) { return S.sel.indexOf(l.id) > -1; });
    var load = items.reduce(function (sum, l) { return sum + l.kw; }, 0);
    // Nur der groesste Einzel-Anlaufzuschlag – nicht alles startet gleichzeitig.
    var extra = items.reduce(function (max, l) { return Math.max(max, l.kw * (l.f - 1)); }, 0);
    var peak = load + extra;
    var kva = peak > 0 ? Math.ceil((peak / 0.8) * 1.15) : 0;

    S.load = load;
    S.peak = peak;
    S.kva = kva;

    $('[data-kpr-load]').textContent = fmt(Math.round(load)) + UNIT_KW;
    $('[data-kpr-peak]').textContent = fmt(Math.round(peak)) + UNIT_KW;
    $('[data-kpr-kva]').textContent = kva ? fmt(kva) + UNIT_KVA : '–' + UNIT_KVA;
    nextS3.disabled = items.length === 0;
  }

  nextS3.addEventListener('click', function () { show('s3'); });

  $('[data-kpr-manual]').addEventListener('click', function () { show('s2b'); });

  /* ─────────────────────────────
     Schritt 2b — Leistung direkt
     ───────────────────────────── */
  var manualInput = $('[data-kpr-manual-value]');
  var manualUnit = $('[data-kpr-manual-unit]');

  $('[data-kpr-next="s3-manual"]').addEventListener('click', function () {
    var v = parseFloat(String(manualInput.value).replace(',', '.'));
    if (!v || v <= 0) {
      manualInput.setAttribute('aria-invalid', 'true');
      manualInput.focus();
      return;
    }
    manualInput.removeAttribute('aria-invalid');
    S.kva = Math.ceil(manualUnit.value === 'kw' ? v / 0.8 : v);
    S.load = Math.round(S.kva * 0.8);
    S.peak = S.load;
    S.manual = true;
    S.sel = [];
    show('s3');
  });

  manualInput.addEventListener('input', function () {
    manualInput.removeAttribute('aria-invalid');
  });

  /* ─────────────────────────────
     Schritt 3 — Zeitraum & Ort
     ───────────────────────────── */
  var dursEl = $('[data-kpr-durations]');
  DURS.forEach(function (d) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kpr-tile';
    b.innerHTML =
      '<span class="kpr-tile__icon"><span class="material-symbols-outlined" aria-hidden="true">' + d.icon + '</span></span>' +
      '<span class="kpr-tile__text"><b>' + d.label + '</b><small>' + d.s + '</small></span>';
    b.addEventListener('click', function () {
      S.dur = d;
      show('s4');
    });
    dursEl.appendChild(b);
  });

  var dateEl = $('[data-kpr-start]');
  if (dateEl) dateEl.min = new Date().toISOString().slice(0, 10);

  /* ─────────────────────────────
     Schritt 4 — Ergebnis & Anfrage
     ───────────────────────────── */
  function pickUnit(kva) {
    var match = FLEET.filter(function (u) { return u.kva >= kva; })[0];
    return match || FLEET[FLEET.length - 1];
  }

  function renderResult() {
    var unit = pickUnit(S.kva);
    S.unit = unit;
    var next = FLEET[FLEET.indexOf(unit) + 1];

    $('[data-kpr-result-value]').textContent = fmt(unit.kva) + UNIT_KVA;

    $('[data-kpr-result-why]').textContent = S.manual
      ? (T.result_why_manual || 'Auf Basis Ihrer Angabe von [kva] kVA ist das die kleinste passende Leistungsklasse.')
          .replace('[kva]', fmt(S.kva))
      : (T.result_why || 'Ihre Verbraucher ergeben rund [load] kW Dauerlast und [peak] kW Anlaufspitze. Mit Leistungsreserve entspricht das [kva] kVA.')
          .replace('[load]', fmt(Math.round(S.load)))
          .replace('[peak]', fmt(Math.round(S.peak)))
          .replace('[kva]', fmt(S.kva));

    $('[data-kpr-result-alt]').textContent = next
      ? (T.result_alt || 'Falls später weitere Verbraucher dazukommen, wäre [kva] kVA die nächstgrößere Klasse. Das besprechen wir im Angebot.')
          .replace('[kva]', fmt(next.kva))
      : '';

    fillHiddenFields();
  }

  /* ─────────────────────────────
     Uebergabe an das Shopify-Kontaktformular
     ───────────────────────────── */
  function summaryLine() {
    var date = dateEl && dateEl.value ? displayDate(dateEl.value) : '';
    var plzEl = $('[data-kpr-plz]');
    var plz = plzEl ? plzEl.value.trim() : '';
    var parts = [];
    if (S.unit) parts.push(fmt(S.unit.kva) + UNIT_KVA);
    if (S.dur) parts.push(S.dur.label);
    if (date) parts.push((T.summary_from || 'ab [date]').replace('[date]', date));
    if (plz) parts.push((T.summary_plz || 'PLZ [plz]').replace('[plz]', function () { return plz; }));
    return parts.join(' · ');
  }

  // ISO-Datum aus dem date-Input in die Schreibweise bringen, die in der
  // Anfrage-Mail gelesen wird.
  function germanDate(iso) {
    return iso ? iso.split('-').reverse().join('.') : '';
  }

  // Datum für die Anzeige: de und uk TT.MM.JJJJ, sonst TT/MM/JJJJ.
  function displayDate(iso) {
    if (!iso) return '';
    return PAGE_LANG === 'de' || PAGE_LANG === 'uk' ? germanDate(iso) : iso.split('-').reverse().join('/');
  }

  function fillHiddenFields() {
    var date = dateEl && dateEl.value ? germanDate(dateEl.value) : '';
    var plzEl = $('[data-kpr-plz]');
    var plz = plzEl ? plzEl.value.trim() : '';
    var names = S.manual
      ? 'Leistung direkt angegeben'
      : LOADS.filter(function (l) { return S.sel.indexOf(l.id) > -1; })
             .map(function (l) { return l.n; })
             .join(', ');

    var map = {
      'kpr-einsatz':    S.useLabel || (S.manual ? 'Direkteingabe' : ''),
      'kpr-verbraucher': names,
      'kpr-leistung':   S.unit ? S.unit.kva + ' kVA' : '',
      'kpr-berechnet':  S.manual
        ? 'Direkteingabe: ' + S.kva + ' kVA'
        : Math.round(S.load) + ' kW Dauerlast / ' + Math.round(S.peak) + ' kW Anlaufspitze / ' + S.kva + ' kVA berechnet',
      'kpr-dauer':      S.dur ? S.dur.t : '',
      'kpr-ab':         date,
      'kpr-plz':        plz
    };

    Object.keys(map).forEach(function (key) {
      var el = root.querySelector('[data-kpr-hidden="' + key + '"]');
      if (el) el.value = map[key];
    });

    // Lesbare Zusammenfassung im Nachrichtenfeld – damit die Anfrage
    // auch in der reinen E-Mail-Ansicht vollstaendig ist.
    var body = root.querySelector('[data-kpr-body]');
    if (body) {
      var lines = [
        'Mietanfrage über den Mietrechner',
        '',
        'Empfohlene Leistungsklasse: ' + (S.unit ? fmtDe(S.unit.kva) + ' kVA' : 'offen'),
        'Berechnungsgrundlage: ' + map['kpr-berechnet'],
        'Einsatzzweck: ' + (map['kpr-einsatz'] || 'nicht angegeben'),
        'Verbraucher: ' + (names || 'nicht angegeben'),
        'Mietdauer: ' + (map['kpr-dauer'] || 'nicht angegeben'),
        'Benötigt ab: ' + (date || 'nicht angegeben'),
        'Einsatzort (PLZ): ' + (plz || 'nicht angegeben')
      ];
      var extra = root.querySelector('[data-kpr-message]');
      if (extra && extra.value.trim()) {
        lines.push('', 'Anmerkung des Kunden:', extra.value.trim());
      }
      body.value = lines.join('\n');
    }
  }

  var form = root.querySelector('[data-kpr-form]');
  if (form) {
    ['change', 'input'].forEach(function (evt) {
      form.addEventListener(evt, function () {
        if (stepEls.s4 && stepEls.s4.classList.contains('is-active')) fillHiddenFields();
      });
    });

    form.addEventListener('submit', function () {
      fillHiddenFields();
      try {
        sessionStorage.setItem(SS_KEY, summaryLine());
      } catch (e) {
        /* Privater Modus – die Zusammenfassung ist dann eben leer. */
      }
      track('kpr_submit', { kva: S.unit ? S.unit.kva : S.kva, dauer: S.dur ? S.dur.t : '' });
    });
  }

  /* ─────────────────────────────
     Schritt 5 — nach erfolgreichem Versand
     ───────────────────────────── */
  if (root.querySelector('[data-kpr-posted]')) {
    var sum = '';
    try {
      sum = sessionStorage.getItem(SS_KEY) || '';
      sessionStorage.removeItem(SS_KEY);
    } catch (e) { /* egal */ }
    var sumEl = $('[data-kpr-summary]');
    if (sumEl && sum) sumEl.textContent = sum;
    show('s5', { force: true, instant: true });
  } else if (root.querySelector('[data-kpr-errors]')) {
    // Shopify hat das Formular zurueckgewiesen (z. B. ungueltige E-Mail):
    // direkt zurueck zum Formularschritt, damit der Fehler sichtbar ist.
    show('s4', { force: true, instant: true });
  }

  /* ─────────────────────────────
     Sticky-CTA
     ───────────────────────────── */
  var sticky = document.querySelector('[data-kpr-sticky]');
  if (sticky) {
    var ticking = false;

    function updateSticky() {
      ticking = false;
      // Erst einblenden, wenn der Rechner nach oben aus dem Bild gescrollt
      // ist. Ein IntersectionObserver auf den Rechner reicht hier nicht:
      // auf Mobil liegt die Karte unter dem Fold, waere also beim Seiten-
      // aufruf schon "nicht sichtbar" — die Leiste wuerde sofort erscheinen,
      // obwohl der Besucher den Rechner noch gar nicht gesehen hat.
      var passed = root.getBoundingClientRect().bottom < 0;
      // Nach abgeschickter Anfrage waere ein "Bedarf berechnen" sinnlos.
      var done = stepEls.s5 && stepEls.s5.classList.contains('is-active');
      var show = passed && !done;

      sticky.classList.toggle('is-visible', show);
      document.body.classList.toggle('kipor-sticky-cta-open', show);
    }

    function requestStickyUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateSticky);
    }

    syncSticky = requestStickyUpdate;
    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate, { passive: true });
    updateSticky();
  }

  /* ─────────────────────────────
     Anker-Links auf den Rechner
     ───────────────────────────── */
  document.addEventListener('click', function (e) {
    // href*= statt href=: Der Theme-Editor kann bei "url"-Einstellungen
    // (z. B. im Final-CTA) den reinen Anker zu einem vollen Pfad
    // ergaenzen — "/pages/…#mietrechner" soll genauso greifen.
    var link = e.target.closest('a[href*="#mietrechner"]');
    if (!link) return;
    e.preventDefault();
    window.scrollTo({
      top: root.getBoundingClientRect().top + window.pageYOffset - 84,
      behavior: 'smooth'
    });
    track('kpr_cta_click', { from: link.getAttribute('data-kpr-source') || 'link' });
  });
})();
